import { render, staticRenderFns } from "./bugManagement.vue?vue&type=template&id=22f72099&scoped=true&"
import script from "./bugManagement.vue?vue&type=script&lang=js&"
export * from "./bugManagement.vue?vue&type=script&lang=js&"
import style0 from "./bugManagement.vue?vue&type=style&index=0&id=22f72099&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f72099",
  null
  
)

export default component.exports